(function () {
  if (window.__salepifyFormGuardInstalled) return;
  window.__salepifyFormGuardInstalled = true;

  function isCartAddForm(form) {
    try {
      if (!form || form.tagName !== 'FORM') return false;
      var action = form.getAttribute('action') || '';
      return /\/cart\/add/.test(action);
    } catch (e) {
      return false;
    }
  }

  function waitForSalepifyReady(timeoutMs) {
    var start = Date.now();
    return new Promise(function (resolve) {
      (function poll() {
        try {
          var offer = window.tlFreeGiftOffer;
          if (offer && offer.rulesReady) return offer.rulesReady.then(resolve, resolve);
        } catch (e) {}
        if (Date.now() - start > timeoutMs) resolve();
        else setTimeout(poll, 30);
      })();
    });
  }

  function handleCartAddSubmit(e) {
    try {
      var form = e.target;
      if (!isCartAddForm(form) || form.__salepifyHandled) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var formData = new FormData(form);
      var returnTo = formData.get('return_to');
      var addUrl = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js';

      waitForSalepifyReady(4000)
        .then(function () {
          return fetch(addUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: formData });
        })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed: ' + res.status);
          window.location.href = returnTo && returnTo !== 'back' ? returnTo : '/cart';
        })
        .catch(function (err) {
          console.error('[Salepify guard] AJAX add thất bại, fallback submit native:', err);
          try {
            form.__salepifyHandled = true;
            HTMLFormElement.prototype.submit.call(form);
          } catch (e2) {}
        });
    } catch (err) {
      console.error('[Salepify guard] submit handler lỗi, để form chạy bình thường:', err);
    }
  }

  document.addEventListener('submit', handleCartAddSubmit, true);

  var nativeSubmit = HTMLFormElement.prototype.submit;
  HTMLFormElement.prototype.submit = function () {
    try {
      if (isCartAddForm(this) && !this.__salepifyHandled) {
        // form.submit() không bắn event 'submit' - phải tự dispatch để handleCartAddSubmit bắt được
        this.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        return;
      }
    } catch (e) {}
    return nativeSubmit.apply(this, arguments);
  };
})();
